import {
  Box,
  ButtonBase,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";

import { trackEvent } from "utils/tracking";

import VideoDialog from "./VideoDialog";

interface Props {
  image: string;
  link: string;
  title: string;
  videoPreview?: string;
}

const SquareThumbnail = ({ image, link, title, videoPreview }: Props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const size = isMobileScreen ? 300 : 400;
  const styles = {
    bg: {
      borderTop: "6px black solid",
      width: size,
      height: "auto",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      position: "relative",
    },
    image: {
      objectFit: "cover",
      width: size,
    },
    icon: {
      background: "rgba(0, 0, 0, 0.4)",
      color: "white",
      fontSize: 15,
      position: "absolute",
      top: "50%",
      left: "50%",
      width: 30,
      height: 30,
      justifyContent: "center",
      transform: "translate(-50%, -50%)",
    },
  };

  const [open, setOpen] = useState(false);
  const playVideo = () => {
    trackEvent("Onboarding Video Clicked", { title });
    setOpen(true);
  };
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6">{title}</Typography>
      <ButtonBase onClick={playVideo} sx={{ width: size }}>
        <Box sx={styles.bg}>
          <Box src={image} component="img" sx={styles.image} />

          <IconButton sx={styles.icon}>
            <Box component="i" className="fa-solid fa-play" />
          </IconButton>
        </Box>
      </ButtonBase>

      <VideoDialog
        title={title}
        videoPreview={videoPreview}
        open={open}
        handleClose={() => setOpen(false)}
        link={link}
      />
    </Box>
  );
};

export default SquareThumbnail;
